import styled from "styled-components";

export const Card = styled.div`
    ${(props) =>
        props.disabled &&
        `
        opacity: 0.5;
    `}

    border-radius: 6px;
    position: relative;
    border: 1px solid #dee2e6;
    background: #f8f9fa;
    width: 100%;
    padding: 7px 14px 14px 14px;
    margin-bottom: 21px;
    min-height: 150px;
`;

export const CardHeader = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    h4 {
        margin: 0;
        color: var(--Pacer-Theme-primaryDarkerColor, #46389e);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 21px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            margin-right: 7px;
        }
    }

    div {
        display: flex;
        justify-content: space-between;
        align-items: center;

        i {
            color: #6860e4;
        }
    }
`;

export const CardBody = styled.div`
    color: #000;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-top: 12px;
    margin-bottom: 28px;
`;

export const CardFooter = styled.div`
    position: absolute;
    bottom: 14px;
    left: 14px;

    span {
        border-radius: 6px;
        margin-right: 2px;
        padding: 3.5px 5.6px;
        border-radius: 6px;
    }

    span:nth-child(odd) {
        color: #1d4ed8;
        font-size: 10.5px;
        font-style: normal;
        font-weight: 500;
        line-height: 15.8px;
        background-color: #bfdbfe;
    }

    span:nth-child(even) {
        color: #46389e;
        font-size: 10.5px;
        font-style: normal;
        font-weight: 500;
        line-height: 15.8px;
        background-color: #dcd7fe;
    }
`;

export const ReportsPageTitle = styled.h3`
    font-size: 24.5px;
    font-weight: 500;
    line-height: 29px;
    margin-bottom: 28px;
`;
